<template>
    <section class="header" :class="{'sg': isSG, 'subpage': !isSG}">
        <div class="header__wrapper">
            <div class="header__left">
                <transition name="fade" appear>
                    <div class="header__return" v-if="isReturn" @click="returnHandle">
                        <IconReturn ></IconReturn>
                    </div>
                </transition>

                <HeaderAvatar 
                    v-if="isLoggedIn && !isParetnZone" 
                    class="header__avatar" 
                    data-aos="fade-in" 
                    data-aos-delay="200"
                    :activeSubProfile="activeSubProfile"
                    :subProfilesList="subProfilesList">
                </HeaderAvatar>

                <router-link v-else :to="{path: '/'}"  class="header__logo">
                    <LogoTop></LogoTop>
                </router-link>
            </div>

            <router-link to="/ulubione" v-if="isFavoritesIcon" class="header__favorites">
                <IconFavoritePin class="header__favorites-icon"></IconFavoritePin>
                <IconFavoritePinMobile class="header__favorites-icon mobile"></IconFavoritePinMobile>
            </router-link>

            <span v-if="isLoggedIn && isParetnZone" class="header__parent-zone">Strefa rodzica</span>
            
            <div class="header__right">
                <router-link 
                    to="/strefa-rodzica" 
                    v-if="isLoggedIn && !isParetnZone"
                    custom
                    v-slot="{ href, navigate }"
                >
                    <a class="header__login animation" v-if="activeSubProfile && activeSubProfile._id" @click="preventHandle"><IconParentZone class="header__login-icon"></IconParentZone><span>Strefa rodzica</span></a>
                    <a class="header__login animation" v-else :href="href" @click="navigate"><IconParentZone class="header__login-icon"></IconParentZone><span>Strefa rodzica</span></a>
                </router-link>

                <a v-if="!isLoggedIn" href="/zaloguj" class="header__login animation" @click.stop.prevent="logIn"><IconLogin class="header__login-icon"></IconLogin><span>Zaloguj się</span></a>
                <a v-if="isLoggedIn && isParetnZone" href="#" class="header__login animation" @click="logOut"><IconLogout class="header__login-icon"></IconLogout><span>Wyloguj się</span></a>

                <button class="header__search-btn" @click="changeSearchState">
                    <IconSearch class="icon"></IconSearch>
                </button>

                <transition name="fade" appear>
                    <HeaderSearch v-if="isSearch" class="header__search"></HeaderSearch>
                </transition>

                <Hamburger :isDropmenu="isDropmenu" @click="changeDropmenuState"></Hamburger>
            </div>
        </div>

        <ModalAccess v-if="isModalAccess"></ModalAccess>
        <transition name="fade" appear>
            <ModalLogin v-if="isModalLogin"></ModalLogin>
        </transition>
        <transition name="fade" appear>
            <PinLock v-if="isPinLock && isPinLock.isOpen"></PinLock>
        </transition>
        <transition name="fade" appear>
            <PinLockChild v-if="isPinLockChild && isPinLockChild.mode && isPinLockChild.mode !== 'hide'"></PinLockChild>
        </transition>        
        <ModalErrorOpen v-if="isModalErrorOpen"/>
        <ModalErrorLoading v-if="isModalErrorLoading"/>
        <!-- <ModalTimeLimit v-if="isModalTimeLimit"/> -->
        <ModalCreateProfil v-if="isModalCreateProfil"/>
        <ModalConfirm v-if="isModalConfirm" :title="confirmTitle" @confirmHandle="confirmHandle"></ModalConfirm>
        <ModalPrivacy v-if="isModalPrivacy" @privacyHandle="privacyHandle"></ModalPrivacy>
    </section>
</template>

<script>
import LogoTop from "./elements/LogoTop.vue";
import IconSearch from "./elements/icons/IconSearch.vue";
import IconReturn from "./elements/icons/IconReturn.vue";
import IconFavoritePin from "./elements/icons/IconFavoritePin.vue";
import IconFavoritePinMobile from "./elements/icons/IconFavoritePinMobile.vue";
import IconLogin from "./elements/icons/IconLogin.vue";
import IconLogout from "./elements/icons/IconLogout.vue";
import IconParentZone from "./elements/icons/IconParentZone.vue";
import HeaderSearch from "./elements/HeaderSearch.vue";
import HeaderAvatar from "./elements/HeaderAvatar.vue";
import ModalAccess from "./modals/ModalAccess.vue";
import ModalCreateProfil from "./modals/ModalCreateProfil.vue"
import ModalErrorLoading from "./modals/ModalErrorLoading.vue";
import ModalErrorOpen from "./modals/ModalErrorOpen.vue";
import ModalLogin from "./modals/ModalLogin.vue";
import Hamburger from "./elements/Hamburger.vue";
import PinLock from "./modals/PinLock.vue";
import PinLockChild from "./modals/PinLockChild.vue";
import ModalConfirm from "./modals/ModalConfirm.vue";
import ModalPrivacy from "./modals/ModalPrivacy.vue";
import globalDataLayer from '../mixins/globalDataLayer';
import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();

export default {
    name: "Header",
    components: {
        IconSearch,
        IconReturn,
        IconFavoritePin,
        IconFavoritePinMobile,
        IconLogin,
        IconLogout,
        IconParentZone,
        HeaderSearch,
        HeaderAvatar,
        LogoTop,
        ModalAccess,
        ModalCreateProfil,
        ModalErrorLoading,
        ModalErrorOpen,
        ModalLogin,
        Hamburger,
        PinLock,
        PinLockChild,
        ModalConfirm,
        ModalPrivacy
    },  
    data() {
        return {
            isModalConfirm: false,
            confirmTitle: 'Czy na pewno chcesz się wylogować?',
            isModalPrivacy: false
        };
    },      
    mixins: [globalDataLayer],  
    watch: {
        getUserData: {
            handler: function(value) {
                if(value && value.data && value.data.length === 0 && value.status && value.status === 200) {
                    this.logoutFinish();
                }
            },
            deep: true,
            immediate: true            
        }
    },
    computed: {
        path() {
            return this.$route.path;
        },
        isSearch() {
            return this.$store.getters.isSearch;
        },
        isDropmenu() {
            return this.$store.getters.isDropmenu;
        },
        isModalAccess() {
            return this.$store.getters.getModalAccess;
        },
        isModalCreateProfil () {
            return this.$store.getters.getModalCreateProfil;
        },
        isModalErrorOpen() {
            return this.$store.getters.getModalErrorOpen;
        },
        isModalErrorLoading() {
            return this.$store.getters.getModalErrorLoading;
        },
        // isModalTimeLimit() {
        //     return this.$store.getters.getModalTimeLimit;
        // },
        isSG() {
            if(this.$route.path === '/start') {
                return true;
            }
            return false;
        },
        isReturn() {
            if(this.$route.path !== '/start' && this.$route.path !== '/') {
                return true;
            }
            return false;
        },
        isModalLogin() {
            return this.$store.getters.getModalLogin;
        },
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        isParetnZone() {
            if(
                this.$route.path === '/strefa-rodzica' ||
                this.$route.path === '/ustawienia' ||
                this.$route.path === '/prywatnosc' ||
                this.$route.path === '/konkursy' ||
                this.$route.path === '/opinie' ||
                this.$route.path === '/faq' 
            ) {
                this.myAccount();
                return true;
            } else {
                return false;
            }
        },
        activeSubProfile() {
            return this.$store.getters.getActiveSubProfile;
        },
        isFavoritesIcon() {
            if(this.activeSubProfile && this.activeSubProfile.favorites && this.isLoggedIn && !this.isParetnZone) {
                return true;
            } else if (!this.activeSubProfile && this.subProfilesList && this.subProfilesList.length && this.isLoggedIn && !this.isParetnZone ) {
                return true;
            }
            return false;
        }, 
        isPinLock() {
            return this.$store.getters.getPinLock;
        },
        isPinLockChild() {
            return this.$store.getters.getPinLockChild;
        },
        subProfilesList() {
            return this.$store.getters.getSubProfiles;
        },
        getUserData() {
            return this.$store.getters.getUserData;
        }        
    },
    methods: {
        changeSearchState() {
            this.$store.dispatch("changeSearchState");
        },
        changeDropmenuState() {
            this.$store.dispatch("changeDropmenuState");
        },
        logIn() {
            this.loginStart();
            window.location.href = `https://user.tvp.pl/login.php?ref=${this.generateHash()}&src=krainaabc&template=abc`;
        },
        logOut() {
            this.logoutStart();
            this.isModalConfirm = true;
            this.$store.dispatch("changeModalBackdrop", true);
        },
        confirmHandle(value) {
            this.$store.dispatch("changeModalBackdrop", false);
            this.isModalConfirm = false;
            if(value) {
                this.$store.dispatch("logout");
                this.$router.push({
                    name: "Categories",
                    path: "/",
                });
            }
        },
        returnHandle() {
            this.$router.go(-1);
        },
        preventHandle() {
            this.myAccount();
            this.$store.dispatch("changePinLock", { isOpen: true, path: '/strefa-rodzica', mode: 'access'});
        },
        privacyHandle() {
            this.isModalPrivacy = false;
        },
        generateHash() {
            return window.btoa(window.location.origin);
        },
    },
    mounted() {
        this.$nextTick(()=> {
            if (this.isLoggedIn) {
                this.$store.dispatch("activeSubProfile");
                this.$store.dispatch("userinfo");
                this.$store.dispatch("subProfiles");
            } 

            setTimeout(()=> {                
                if (cookies.get("TVP_ABC_PRIVACY") || this.$route.path === '/regulamin' || this.$route.path === '/polityka') {
                    this.isModalPrivacy = false;
                    document.body.classList.remove('scroll-lock');
                } else {
                    this.isModalPrivacy = true;
                    document.body.classList.add('scroll-lock');
                }
            }, 0);
        });
    }
}
</script>
